export enum ContactEventsE {
  CONTACT_UPLOAD = 'contact-upload',
}
